export default "__VITE_ASSET__CnNdFqn___"